import {
  INVOICE_TASK_CREATE_FAIL,
  INVOICE_TASK_CREATE_REQUEST,
  INVOICE_TASK_CREATE_RESET,
  INVOICE_TASK_CREATE_SUCCESS,
  INVOICE_TASK_DELETE_FAIL,
  INVOICE_TASK_DELETE_REQUEST,
  INVOICE_TASK_DELETE_RESET,
  INVOICE_TASK_DELETE_SUCCESS,
  INVOICE_TASK_GET_FAIL,
  INVOICE_TASK_GET_REQUEST,
  INVOICE_TASK_GET_SUCCESS,
  INVOICE_TASK_LIST_FAIL,
  INVOICE_TASK_LIST_REQUEST,
  INVOICE_TASK_LIST_SUCCESS,
  INVOICE_TASK_REMINDER_OFF_FAIL,
  INVOICE_TASK_REMINDER_OFF_REQUEST,
  INVOICE_TASK_REMINDER_OFF_RESET,
  INVOICE_TASK_REMINDER_OFF_SUCCESS,
  INVOICE_TASK_UPDATE_FAIL,
  INVOICE_TASK_UPDATE_REQUEST,
  INVOICE_TASK_UPDATE_RESET,
  INVOICE_TASK_UPDATE_SUCCESS,
} from "../constants/taskConstants";

export const taskListReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_TASK_LIST_REQUEST:
      return { loading: true };
    case INVOICE_TASK_LIST_SUCCESS:
      return { loading: false, tasks: action.payload };
    case INVOICE_TASK_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const taskCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_TASK_CREATE_REQUEST:
      return { loading: true };
    case INVOICE_TASK_CREATE_SUCCESS:
      return { loading: false, success: action.payload };
    case INVOICE_TASK_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case INVOICE_TASK_CREATE_RESET:
      return { loading: false, success: "" };
    default:
      return state;
  }
};

export const taskGetReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_TASK_GET_REQUEST:
      return { loading: true };
    case INVOICE_TASK_GET_SUCCESS:
      return { loading: false, taskRec: action.payload };
    case INVOICE_TASK_GET_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const taskUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_TASK_UPDATE_REQUEST:
      return { loading: true };
    case INVOICE_TASK_UPDATE_SUCCESS:
      return { loading: false, success: action.payload };
    case INVOICE_TASK_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case INVOICE_TASK_UPDATE_RESET:
      return { loading: false, success: "" };
    default:
      return state;
  }
};

export const taskDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_TASK_DELETE_REQUEST:
      return { loading: true };
    case INVOICE_TASK_DELETE_SUCCESS:
      return { loading: false, success: action.payload };
    case INVOICE_TASK_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case INVOICE_TASK_DELETE_RESET:
      return { loading: false, success: "" };
    default:
      return state;
  }
};

export const taskReminderReducer = (state = {}, action) => {
  switch (action.type) {
    case INVOICE_TASK_REMINDER_OFF_REQUEST:
      return { loading: true };
    case INVOICE_TASK_REMINDER_OFF_SUCCESS:
      return { loading: false, success: action.payload };
    case INVOICE_TASK_REMINDER_OFF_FAIL:
      return { loading: false, error: action.payload };
    case INVOICE_TASK_REMINDER_OFF_RESET:
      return { loading: false, success: "" };
    default:
      return state;
  }
};
